import { JobItemViewModel } from './jobItemViewModel';

export class JobDetailsItemViewModel extends JobItemViewModel {}
